import { locationSelectAllValue } from '@constants/locationSelectAllValue';

import { getLocationSelectNode } from '@helpers/getLocationSelectNode';

import { createStore } from '@store/createStore';

export const useAppStore = createStore(
  (set) => ({
    rtl: null,
    language: null,
    locationSelectValue: locationSelectAllValue,
    error: '',

    actions: {
      setAppRtl: (rtl) => set({ rtl }),
      setAppLanguage: (language) => set({ language }),
      setAppLocationSelectValue: (locationSelectValue) =>
        set({ locationSelectValue: getLocationSelectNode(locationSelectValue) }),
      setError: (error) => set({ error }),
    },
  }),
  'AppStore',
);

export const useAppActions = () => useAppStore((state) => state.actions);

export const selectAppRtl = () => useAppStore((state) => state.rtl);
export const selectAppLanguage = () => useAppStore((state) => state.language);
export const selectAppLocationSelectValue = () => useAppStore((state) => state.locationSelectValue);
export const selectAppError = () => useAppStore((state) => state.error);
